import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { filterJournals } from "../../redux/slice/accounting/accountingSlice";
import Select from "../form/select/Select";
import moment from "moment/moment";

const FilterAccounts = ({ getSearcInput }) => {
  const { all_accounts } = useSelector((state) => state?.accounting);
  const { offices } = useSelector((state) => state?.office?.offices);
  const { user } = useSelector((state) => state?.auth?.user);
  const currentDate = new Date().toISOString().split("T")[0];

  const dispatch = useDispatch();
  const onSubmit = (values, { resetForm }) => {
    getSearcInput(values);
    dispatch(filterJournals(values));
    // resetForm();
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      transaction_to: currentDate,
      transaction_from: currentDate,
      account_id: "",
      manual_entries: "",
      office_id: user?.office_id,
    },
    validationSchema: Yup.object().shape({
      transaction_to: Yup.string().required("Transaction to is required"),
      transaction_from: Yup.string().required("Transaction from is required"),
    }),
    validate: (values) => {
      let errors = {};
      if (values.transaction_from > values.transaction_to) {
        errors.transaction_from =
          "transaction-from cannot be future to transaction-to";
      }
      return errors;
    },
    onSubmit,
  });

  return (
    <>
      <div className='mt-1' style={{ margin: "0px 10px" }}>
        <form className='row ' onSubmit={handleSubmit}>
          <div className='col-md-7 card py-2'>
            <div className='row mb-2'>
              <div className=' col-md-4 text-right sm-text-end'>
                <label htmlFor='inputPassword5' className='form-label'>
                  Account
                </label>
              </div>
              <div className='col-md-7'>
                <Select
                  // ref={selectRef}
                  isError={errors?.account_id && touched?.account_id}
                  name='account_id'
                  data={all_accounts?.filterd_account?.map((item, i) => ({
                    label: item?.account_name,
                    value: item?.id,
                  }))}
                  value={values?.account_id}
                  onChange={(selectedOption) =>
                    setFieldValue("account_id", selectedOption?.value)
                  }
                  onBlur={() => {
                    handleBlur({ target: { name: "account_id" } });
                  }}
                />
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-4 text-right sm-text-end mt-1'>
                <label htmlFor='inputPassword5' className='form-label'>
                  Office
                </label>
              </div>

              <div className='col-md-7'>
                <Select
                  // ref={selectRef}
                  name='office_id'
                  data={offices?.map((item) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  value={values?.office_id}
                  onChange={(selectedOption) =>
                    setFieldValue("office_id", selectedOption?.value)
                  }
                  onBlur={() => {
                    handleBlur({ target: { name: "office_id" } });
                  }}
                />
              </div>
            </div>

            <div className='row mb-2'>
              <div className=' col-md-4 text-right sm-text-end mt-1'>
                <label
                  htmlFor='inputPassword5'
                  className={`form-label ${
                    errors.transaction_from &&
                    touched.transaction_from &&
                    "text-danger"
                  }`}
                >
                  Transactions from <span className='text-danger'>*</span>
                </label>
              </div>
              <div className='col-md-7'>
                <input
                  type='date'
                  name='transaction_from'
                  value={values?.transaction_from}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id='transaction_from'
                  className={`form-control form-control-sm ${
                    errors.transaction_from &&
                    touched.transaction_from &&
                    "is-invalid"
                  }`}
                />
                {errors.transaction_from && touched.transaction_from && (
                  <span className='text-danger'>{errors.transaction_from}</span>
                )}
              </div>
            </div>
            <div className='row mb-2'>
              <div className=' col-md-4 text-right sm-text-end mt-1'>
                <label
                  htmlFor='inputPassword5'
                  className={`form-label  ${
                    errors.transaction_to &&
                    touched.transaction_to &&
                    "text-danger"
                  }`}
                >
                  To <span className='text-danger'>*</span>
                </label>
              </div>
              <div className='col-md-7'>
                <input
                  type='date'
                  name='transaction_to'
                  value={values?.transaction_to}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id='transaction_to'
                  className={`form-control form-control-sm ${
                    errors.transaction_to &&
                    touched.transaction_to &&
                    "is-invalid"
                  }`}
                />
                {errors.transaction_to && touched.transaction_to && (
                  <span className='text-danger'>{errors.transaction_to}</span>
                )}
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-4 text-right sm-text-end mt-1'>
                <label htmlFor='inputPassword5' className='form-label'>
                  Manual Entries only
                </label>
              </div>

              <div className='col-md-7'>
                <Select
                  name='manual_entries'
                  id='manual_entries'
                  data={["Yes", "No"].map((item) => ({
                    label: item,
                    value: item,
                  }))}
                  value={values?.manual_entries}
                  onChange={(selectedOption) =>
                    setFieldValue("manual_entries", selectedOption?.value)
                  }
                />
              </div>
            </div>
            <div className='row mb-'>
              <div className='col-md-4'></div>
              <div className='col-md-7'>
                <button
                  type='submit'
                  className='btn btn-primary btn-sm rounded'
                >
                  Filter
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default FilterAccounts;
